import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import Button from '@/ui-kit/components/Button/Button';

const TerminateIdProtectSuccess = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation('Modal', { keyPrefix: 'TerminateIdProtectSuccess' });

  return (
    <Modal title={t('title')}>
      <p>{t('info')}</p>

      <ModalActions>
        <Button onClick={closeModal}>{t('button')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default TerminateIdProtectSuccess;
